const DEFAULT_APP_BASE_PATH = '/';

export const normalizeAppBasePath = (value?: string) => {
  const normalized = value?.trim();
  if (!normalized || normalized === '/') {
    return DEFAULT_APP_BASE_PATH;
  }
  return `/${normalized.replace(/^\/+|\/+$/g, '')}`;
};

export const APP_BASE_PATH = normalizeAppBasePath(
  process.env.REACT_APP_BASE_PATH,
);

export const APP_PUBLIC_PATH =
  APP_BASE_PATH === '/' ? APP_BASE_PATH : `${APP_BASE_PATH}/`;

export const withAppPublicPath = (assetPath: string) =>
  `${APP_PUBLIC_PATH}${assetPath.replace(/^\/+/, '')}`;

export const stripAppBasePath = (pathname: string) => {
  const normalizedPath = pathname || '/';
  if (APP_BASE_PATH === '/') {
    return normalizedPath;
  }
  if (normalizedPath === APP_BASE_PATH) {
    return '/';
  }
  const basePrefix = `${APP_BASE_PATH}/`;
  if (normalizedPath.startsWith(basePrefix)) {
    return normalizedPath.slice(APP_BASE_PATH.length) || '/';
  }
  return normalizedPath;
};

export const normalizeAppRoutePath = (path: string | null | undefined) => {
  const rawPath = path?.trim();
  if (!rawPath) {
    return '/';
  }

  try {
    const url = new URL(
      rawPath,
      typeof window === 'undefined' ? 'http://localhost' : window.location.origin,
    );
    return `${stripAppBasePath(url.pathname)}${url.search}${url.hash}`;
  } catch {
    const pathWithSlash = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
    return stripAppBasePath(pathWithSlash);
  }
};

export const getCurrentAppRoutePath = () => {
  if (typeof window === 'undefined') {
    return '/';
  }
  return normalizeAppRoutePath(
    `${window.location.pathname}${window.location.search}${window.location.hash}`,
  );
};

export const isAppRoutePath = (pathname: string, targetPath: string) =>
  stripAppBasePath(pathname) === targetPath;
